import script from "./WorkflowSettingsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkflowSettingsDialog.vue?vue&type=script&setup=true&lang=js"

import "./WorkflowSettingsDialog.vue?vue&type=style&index=0&id=596ca922&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-596ca922"]])

export default __exports__